/**
 * 枚举类
 * @author meilin.huang
 */
export class Enum {
  /**
   * 添加枚举字段
   * field: 枚举字段
   * label: 界面显示
   * value: 枚举值
   */
  add(field, label, value) {
    this[field] = { label, value, field }
    return this
  }

  /**
   * 根据枚举value获取其label
   */
  getLabelByValue(value) {
    // 字段不存在返回‘’
    if (value === undefined || value === null) {
      return ''
    }
    for (const i in this) {
      const e = this[i]
      if (e && e.value === value) {
        return e.label
      }
    }

    return ''
  }

  /**
   * 根据枚举filed获取其label
   */
  getLabelByField(field) {
    // 字段不存在返回‘’
    if (field === undefined || field === null) {
      return ''
    }
    for (const i in this) {
      const e = this[i]
      if (e && e.field === field) {
        return e.label
      }
    }
    return ''
  }

    getFieldByLabel(label) {
        // 字段不存在返回‘’
        if (label === undefined || label === null) {
            return ''
        }
        for (const i in this) {
            const e = this[i]
            if (e && e.label === label) {
                return e.field
            }
        }
        return ''
    }
}
